import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import moment from 'moment';

import {
    getInvoiceDisputeComments,
    setInvoiceDisputeError,
    insertInvoiceDisputeComments,
    resetInvoiceDisputeComments, 
    deleteInvoiceDisputeComments
} from "../../../../constants/model-reducers/external/invoice/dispute/dispute-comments.setting";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../../utils/api.utils";
import { convertToLocalDateToUTCDate, getLocalTimeZone } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    InvoiceDisputeComments: [],
    pageIndex: 1,
    hasMoreData: false
});

const initialState = defaultState();

export const disputeCommentActions = {
    postInvoiceDisputeComments: (disputeID, filename, fileData, comment) => async (dispatch, state) => {

        const timezoneOffset = new Date().getTimezoneOffset() * -1;
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("DisputeID", disputeID);

        var res = await httpPostFile(`external/dispute/setInvoiceDisputeComments?timeZoneOffset=${timezoneOffset}`, formData);

        if (res != null) {
            dispatch({
                type: insertInvoiceDisputeComments,
                InvoiceDisputeComments: res?.data[0],
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false,
                hasMoreData: res?.hasMore
            });
        } else {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    },

    getInvoiceDisputeComments: (disputeID, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const existingComments = state().invoiceDisputeComments.InvoiceDisputeComments;
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;


        var res = await httpGet(
            `external/dispute/getInvoiceDisputeComments/${pageIndex}/${pageSize}?disputeID=${disputeID}` +
            (lastCommentId != null ? `&lastCommentId=${lastCommentId}` : "")
        );

        if (res != null) {
            dispatch({
                type: getInvoiceDisputeComments,
                InvoiceDisputeComments: res.comments,
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    },

    clearInvoiceDisputeComments: () => (dispatch, state) => {
        dispatch({
            type: resetInvoiceDisputeComments,
            InvoiceDisputeComments: [],
        })
    },

    deleteInvoiceDisputeComments: (commentId) => async (dispatch, state) => {
        const userId = sessionStorage.getItem("UserID");
        const res = await httpPost(`external/dispute/disputeDeleteComment/${commentId}/${userId}`);

        if (res == null) {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    }

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceDisputeComments: {
            return {
                ...state,
                InvoiceDisputeComments: [
                    ...state.InvoiceDisputeComments,
                    ...action.InvoiceDisputeComments],
                hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
            };
        }
        case resetInvoiceDisputeComments: {
            return {
                ...state,
                InvoiceDisputeComments: action.InvoiceDisputeComments,
                hasMoreComments: false,
                pageIndex: 1
            }
        }
        case setInvoiceDisputeError:{
            return {
                ...state,
                isInvoiceDisputeError: action.isInvoiceDisputeError,
                isInvoiceDisputeLoaded: action.isInvoiceDisputeLoaded
            }
        }
        case insertInvoiceDisputeComments: {
            const disputeComments = Array.isArray(action.InvoiceDisputeComments)
                                    ? action.InvoiceDisputeComments : [action.InvoiceDisputeComments] 
            const existingComments = Array.isArray(state.InvoiceDisputeComments)
                                    ? state.InvoiceDisputeComments : [state.InvoiceDisputeComments]
            const combinedComments = [
                ...disputeComments,
                ...existingComments
            ];

            const currentVisibleCount = state.InvoiceDisputeComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !==1; 
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments
            }

            return {
                ...state,
                InvoiceDisputeComments: combinedComments.length === 1 ? disputeComments : updatedComments,
                hasMoreComments: hasMore,
            }
        }
        default:
            return state;
    }
}